export const INSPECTION_REPORT_STATUS = {
  ACTIVE: "ACTIVE",
  FINALIZED: "FINALIZED",
  SUBMITTED: "SUBMITTED",
};
